import script from "./CommonTable2.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonTable2.vue?vue&type=script&lang=ts&setup=true"

import "./CommonTable2.vue?vue&type=style&index=0&id=0778f42b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0778f42b"]])

export default __exports__